"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var metasActions = require("@caddigital/sok-reducers/lib/actions/subproject/metas");
var schemaActions = require("@caddigital/sok-reducers/lib/actions/subproject/schema");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
require("./subproject.scss");
var mapStateToProps = function (state) {
    return {
        subproject: state.subproject
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (projectId) { return (dispatch(metasActions.fetchRequest()),
        dispatch(schemaActions.fetchSchemaRequest(projectId))); },
    add: function (item) { return dispatch(schemaActions.add(item)); },
    move: function (item, direction) {
        return dispatch(schemaActions.move(item, direction));
    },
    remove: function (item) { return dispatch(schemaActions.remove(item)); },
    save: function (projectId, schema) {
        return dispatch(schemaActions.saveRequest(projectId, schema));
    },
    clear: function () { return (dispatch(metasActions.clear()), dispatch(schemaActions.clear())); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#endregion
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('metas', 'setMetas', []), (0, recompose_1.withState)('schemaList', 'setSchemaList', []), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.isOpen) {
            if (this.props.isOpen !== prevProps.isOpen ||
                (this.props.subproject.metas.status !==
                    prevProps.subproject.metas.status &&
                    this.props.subproject.metas.status === 'STANDBY' &&
                    prevProps.subproject.metas.status !== 'STANDBY')) {
                this.props.fetch(this.props.projectId);
            }
        }
        else if (!this.props.isOpen && this.props.isOpen !== prevProps.isOpen) {
            this.props.clear();
        }
        if (this.props.subproject.schema.list !==
            prevProps.subproject.schema.list ||
            this.props.subproject.metas.list !== prevProps.subproject.metas.list) {
            var map_1 = this.props.subproject.schema.list.reduce(function (acc, item) {
                acc[item.identifier] = true;
                return acc;
            }, {});
            var filtered = this.props.subproject.metas.list.filter(function (x) { return map_1[x.identifier] !== true; });
            this.props.setMetas(filtered);
        }
        if (this.props.subproject.schema.list !== prevProps.subproject.schema.list) {
            this.props.setSchemaList(__spreadArray([], this.props.subproject.schema.list, true).reverse());
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen || this.props.isOpen !== nextProps.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.RequestStatusBox, { className: 'project-wizard-modal-subproject-status', status: props.subproject.schema.saveStatus },
            (0, translation_1.getLocalization)("subproject/status/saving"),
            (0, translation_1.getLocalization)("subproject/status/saved"),
            (0, translation_1.getLocalization)("subproject/status/failed")),
        React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'project-wizard-modal-subproject' },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleModal(false); } }, (0, translation_1.getLocalization)('subproject/schema/header')),
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", null,
                    React.createElement(sok_ui_1.Dropdown2, null,
                        React.createElement(sok_ui_1.Button, { border: 'green', color: 'dark-gray', size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus-circle' }), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' }), text: (0, translation_1.getLocalization)('subproject/schema/addMetadata') }),
                        React.createElement(sok_ui_1.Dropdown2Menu, null,
                            props.metas.length === 0 && (React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('subproject/schema/empty'))),
                            props.metas.map(function (x) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.add(x); } }, (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name)))); })))),
                props.subproject.schema.status === 'FAILURE' && (React.createElement("div", { className: 'center' },
                    React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(props.projectId); } })))),
                props.subproject.schema.status === 'FETCHING' && (React.createElement("div", { className: 'center' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.subproject.schema.status === 'FETCHED' && (React.createElement(sok_ui_1.Table.Table, { className: 'meta-list striped' },
                    React.createElement(sok_ui_1.Table.Body, null, props.schemaList.map(function (x) { return (React.createElement(sok_ui_1.Table.Row, { key: x.identifier },
                        React.createElement(sok_ui_1.Table.Column, { className: 'name' }, (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name))),
                        React.createElement(sok_ui_1.Table.Column, { className: 'move-up' },
                            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-chevron-down', disabled: x.mandatory || x.order <= 2, onClick: function () { return props.move(x, -1); } })),
                        React.createElement(sok_ui_1.Table.Column, { className: 'move-down' },
                            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-chevron-up', disabled: x.mandatory || x.order >= props.schemaList.length - 1, onClick: function () { return props.move(x, 1); } })),
                        React.createElement(sok_ui_1.Table.Column, { className: 'remove' },
                            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-times', className: 'red', disabled: x.mandatory, onClick: function () { return props.remove(x); } })))); }))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('buttons/save'), color: 'base-green', onClick: function () {
                        return props.subproject.schema.schemaId !== undefined &&
                            props.save(props.projectId, props.subproject.schema.list);
                    } }),
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('buttons/cancel'), color: 'dark-gray', onClick: function () { return props.toggleModal(false); } })))));
});
